export default __webpack_public_path__ + "static/media/none.56f96af5.png";